import Cookies from "js-cookie";
import { LOCALE_COOKIE_NAME } from "@/lib/locale/constants";
import type { CheckoutGeoPricingEligibility } from "@/lib/checkout-geo-pricing/types";
import resolveCountryName from "./resolveCountryName";
import { resolvedGeoPricingText } from "./resolvedGeoPricingText";

export const resolveGeoPricingRibbonCopy = (
  text: string | undefined,
  checkoutGeoPricing: CheckoutGeoPricingEligibility,
): string => {
  const language = Cookies.get(LOCALE_COOKIE_NAME) ?? "en";
  const countryCode = checkoutGeoPricing.countryCode ?? "US";
  const countryName = resolveCountryName(countryCode, language) ?? countryCode;

  if (!text) {
    return "";
  }

  return (
    resolvedGeoPricingText(text, {
      percentageDiscount: checkoutGeoPricing.discountPercentage ?? 0,
      countryName,
    }) ?? ""
  );
};
